import React from 'react'
import SideNavMenu from './SideNavMenu'

import styles from '@/modules/products/ProductDocumentPage/DisplayViews/displayViews.module.scss'



const GlobalSideNavMenu = ({ 
    globalItems
}: { 
    globalItems: any
}) => {

    const GlobalSideNavMenuItems = globalItems?.map((item: any) => {

        const renderMenuItem = (item: any) => {
            
            return (
                <>
                    <p className={styles.productNameTitle}>{item.title}</p>
                    <SideNavMenu items={item.items} />
                </>
            )
        }

        return renderMenuItem(item)
    })

    return GlobalSideNavMenuItems


}

export default GlobalSideNavMenu